// Configuration des états
export const ETAT_ENREGISTRE = 'Enregistre';
export const ETAT_PAYE = 'Paye';

// Liste des états pour le filtre
export const FACTURE_ETAT = [
  { code: ETAT_ENREGISTRE, libelle: 'Enregistrée' },
  { code: ETAT_PAYE, libelle: 'Payée' },
];
